import { useState, useEffect } from 'react';
import classNames from "classnames";

export default function useGetClasses(isOpen: boolean) {
  const [state, setState] = useState('');

  useEffect(() => {
    setState(classNames(
      'app-select-search',
      isOpen ? 'app-select-search_open' : ''
    ));
  }, [isOpen]);

  return state;
}